module.exports = __webpack_public_path__ + "img/13.cbe6b977.webp";